import { render, staticRenderFns } from "./LeadsWidget.vue?vue&type=template&id=6625aaee&scoped=true"
import script from "./LeadsWidget.vue?vue&type=script&lang=js"
export * from "./LeadsWidget.vue?vue&type=script&lang=js"
import style0 from "./LeadsWidget.vue?vue&type=style&index=0&id=6625aaee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6625aaee",
  null
  
)

export default component.exports